import { useState, useEffect } from "react";
import "./sidebar.css";
import { NavLink, useLocation } from "react-router-dom";

const brandmoSubdomainName = process.env.REACT_APP_BRANDMOSUBDOMAIN;
const brandmoId = process.env.REACT_APP_BRANDMOUSERID;

// Get subdomain (adjust if hosted on brandmo)
const hostname = window.location.hostname;
const subdomain = hostname.includes(brandmoSubdomainName)
  ? brandmoSubdomainName
  : hostname.split(".")[0];

//console.log("==========Sidebar=============")
//console.log(subdomain)
//console.log(brandmoSubdomainName)
//console.log("===========Sidebar End============")

const SideBar = ({ isSidebarOpen }) => {
  const [mobMenu, setMobMenu] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [brandAccess, setBrandAccess] = useState(null);
  const [userId, setUserId] = useState(null);
  const location = useLocation();
  //const brandmoId = "15"

  // Submenu open/close used to be driven entirely by Bootstrap's JS
  // (data-bs-toggle/data-bs-target), which mutates the DOM directly by
  // adding a "show" class. That fought with React: SideBar re-renders on
  // every route change (it reads useLocation()), and React resets each
  // collapse <div> back to whatever its JSX says — which never included
  // "show" — wiping out Bootstrap's change. That's why a submenu would
  // randomly snap shut, especially right after clicking a link inside it
  // (which navigates and triggers exactly that re-render). Tracking open
  // state in React itself fixes this — React's own re-renders can no longer
  // disagree with what's actually shown.
  const [openSections, setOpenSections] = useState({ dashboard: true });
  const toggleSection = (id) =>
    setOpenSections((prev) => ({ ...prev, [id]: !prev[id] }));
  const [isPromoSectionOpen, setIsPromoSectionOpen] = useState(true);

  useEffect(() => {
    const role = localStorage.getItem("role");
    const userId = localStorage.getItem("user_id");
    setUserId(userId);

    setUserRole(role);

    const brandAccess = localStorage.getItem("brand_access");
    setBrandAccess(brandAccess);
  }, []);

  //const aiName = "TASHA";

  // Define the parent-child route structure
  const routes = {
    dashboard: ["/supply-overview", "/demand-overview", "brand-overview"],
    event: ["/event"],
    segments: [
      "/audience-segments",
      "/data-architecture",
      "/product-spine",
      "/dsp",
      "/reach",
      "/segments",
      "/geo",
      "/publishers",
    ],
    tool: [
      "/deals",
      "/map-deals",
      "compare-csv",
      "/margin-history",
      "/segment-request",
      "/tasha",
      "/compare-deal",
    ], // Add more routes as needed
    users: ["/users"],
    aiManagement: ["/suggestions", "/create-tag" ,"site-app","site-expansion"],
    innovationAds: ["/innovation-ads", "/innovation-ads/qr-code", "/innovation-ads/shoppable"],

    supply: ["/supplypartners"],
    demand: ["/demand-partners"],
    agency: ["/agency-partners"],
    brand: ["/brand-partners"],
    pmpSetupGuide: ["/dv360", "/ttd","/amazon"],
    advanceAnalytics: ["/agency-overview", "/heatmap"],
    partners: [
      "/supplypartners",
      "/demand-partners",
      "/agency-partners",
      "/brand-partners",
    ],
  };

  const isActive = (paths) => paths.some((path) => location.pathname === path);

  // Maps each collapsible section's id to the routes that belong under it, so
  // navigating (directly, or via a bookmark/refresh) auto-expands the right
  // section instead of landing on an active link buried in a closed menu.
  const sectionRoutes = {
    audienceSegments: routes.segments,
    dashboard: routes.dashboard,
    pmpSetupGuide: routes.pmpSetupGuide,
    users: routes.users,
    partners: routes.partners,
    tools: routes.tool,
    aiManagement: routes.aiManagement,
    innovationAds: routes.innovationAds,
    advanceAnalytics: routes.advanceAnalytics,
  };

  useEffect(() => {
    setOpenSections((prev) => {
      const next = { ...prev };
      Object.entries(sectionRoutes).forEach(([id, paths]) => {
        if (isActive(paths)) next[id] = true;
      });
      return next;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  console.log("==========Sidebar=============");
  console.log(subdomain);
  console.log(brandmoSubdomainName);
  console.log(brandmoId);
  console.log("===========Sidebar End============");

  if (subdomain === brandmoSubdomainName) {
    return (
      <>
        <button className="mob-toggle-btn" onClick={() => setMobMenu(!mobMenu)}>
          {mobMenu ? (
            <span className="cross-mob">&times;</span>
          ) : (
            <span>&#9776;</span>
          )}
        </button>
        <div
          className={`fixed-sidebar ${mobMenu ? "active" : ""} ${isSidebarOpen ? "show" : "hide"
            }`}
          id="fixed_sidebar"
        >
          {/* <div className="logo">
            <img src="../../../assets/images/logo.svg" alt="logo" />
          </div> */}
          <div className="menu-list">
            <ul className="list-wraper">
              <>
                <li></li>
                <li>
                  <label
                    onClick={() => setIsPromoSectionOpen((v) => !v)}
                    className={`d-flex justify-content-between ${isActive(routes.segments) ? "active" : ""
                      }`}
                  >
                    <span className="d-flex align-items-center">
                      <i className="fa-solid fa-gauge"></i> Dashboard{" "}
                    </span>{" "}
                    <i className="fa-solid fa-chevron-down"></i>
                  </label>
                  <div
                    id="audienceSegments"
                    className={`collapse inner-collapse ${isPromoSectionOpen ? "show" : ""}`}
                  >
                    <NavLink
                      to="/data-architecture"
                      className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                    >
                      Data Architecture
                    </NavLink>
                    <NavLink
                      to="/product-spine"
                      className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                    >
                      Product Spine
                    </NavLink>
                    <NavLink
                      to="/audience-segments"
                      className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                    >
                      Segments
                    </NavLink>
                    <NavLink
                      to="/tasha"
                      title="BrandMo's Engine for Agentic Modeling"
                      className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                    >
                      BEAM
                    </NavLink>
                  </div>
                </li>
              </>
            </ul>
          </div>
        </div>
        <div className={mobMenu ? "overlay" : ""}></div>
      </>
    );
  }

  return (
    <>
      <button className="mob-toggle-btn" onClick={() => setMobMenu(!mobMenu)}>
        {mobMenu ? (
          <span className="cross-mob">&times;</span>
        ) : (
          <span>&#9776;</span>
        )}
      </button>
      <div
        className={`fixed-sidebar ${mobMenu ? "active" : ""} ${isSidebarOpen ? "show" : "hide"
          }`}
        id="fixed_sidebar"
      >
        {/* <div className="logo">
          <img src="../../../assets/images/logo.svg" alt="logo" />
        </div> */}
        <div className="menu-list">
          <ul className="list-wraper">
            {userRole && (
              <>
                {(userRole === "client" ||
                  userRole === "sales_user" ||
                  userRole === "admin" ||
                  userRole === "super_admin" ||
                  userRole === "demo") && (
                    <li>
                      <label
                        onClick={() => toggleSection("audienceSegments")}
                        className={`d-flex justify-content-between ${isActive(routes.segments) ? "active" : ""
                          }`}
                      >
                        <span className="d-flex align-items-center">
                          <i className="fa-solid fa-gauge"></i> Audience
                        </span>{" "}
                        <i className="fa-solid fa-chevron-down"></i>
                      </label>
                      <div
                        id="audienceSegments"
                        className={`collapse inner-collapse ${openSections.audienceSegments ? "show" : ""}`}
                      >
                        <NavLink
                          to="/data-architecture"
                          className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                        >
                          Data Architecture
                        </NavLink>
                        <NavLink
                          to="/product-spine"
                          className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                        >
                          Product Spine
                        </NavLink>
                        <NavLink
                          to="/audience-segments"
                          className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                        >
                          Audience
                        </NavLink>

                        {userRole === "super_admin" && (
                          <NavLink
                            to="/dsp"
                            className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                          >
                            DSP
                          </NavLink>
                        )}
                        {userRole === "super_admin" && (
                          <NavLink
                            to="/geo"
                            className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                          >
                            Geo
                          </NavLink>
                        )}
                        {userRole === "super_admin" && (
                          <NavLink
                            to="/segments"
                            className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                          >
                            Segments
                          </NavLink>
                        )}
                        {userRole === "super_admin" && (
                          <NavLink
                            to="/reach"
                            className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                          >
                            Reach
                          </NavLink>
                        )}
                        {userRole === "super_admin" && (
                          <NavLink
                            to="/publishers"
                            className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                          >
                            Publishers
                          </NavLink>
                        )}
                      </div>
                    </li>
                  )}
                <li>

                {/*  ============================= DASHOARD ===================================== */}

                  <label
                    onClick={() => toggleSection("dashboard")}
                    className={`d-flex justify-content-between ${isActive(routes.dashboard) ? "active" : ""}`}>
                    <span className="d-flex align-items-center">
                      <i className="fa-solid fa-display"></i> Dashboard{" "}
                    </span>{" "}
                    <i className="fa-solid fa-chevron-down"></i>
                  </label>
                  <div id="dashboard" className={`collapse inner-collapse ${openSections.dashboard ? "show" : ""}`}>
                    {(userRole === "sales_user" ||
                      userRole === "admin" ||
                      userRole === "super_admin" ||
                      userRole === "client" ||
                      userRole === "demo") && (
                        <NavLink
                          to="/supply-overview"
                          className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                        >
                          Overview Supply
                        </NavLink>
                      )}
                    {(userRole === "sales_user" ||
                      userRole === "admin" ||
                      userRole === "super_admin" ||
                      userRole === "demand") && (
                        <NavLink
                          to="/demand-overview"
                          className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                        >
                          Overview Demand
                        </NavLink>
                      )}
                    {(userRole === "sales_user" ||
                      userRole === "admin" ||
                      userRole === "super_admin" ||
                      brandAccess) && (
                        <NavLink
                          to="/brand-overview"
                          className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                        >
                          Overview Brand
                        </NavLink>
                      )}
                  </div>
                </li>

                <li>
                  <label
                    onClick={() => toggleSection("pmpSetupGuide")}
                    className={`d-flex justify-content-between`}
                  >
                    <span className="d-flex align-items-center">
                      <i class="fa-solid fa-info-circle"></i> PMP Setup Guide
                    </span>
                    <i className="fa-solid fa-chevron-down"></i>
                  </label>

                  <div id="pmpSetupGuide" className={`collapse inner-collapse ${openSections.pmpSetupGuide ? "show" : ""}`}>
                    {(userRole === "sales_user" ||
                      userRole === "admin" ||
                      userRole === "super_admin" ||
                      userRole === "client" ||
                      userRole === "demand" ||
                      userRole === "demo") && (
                        <NavLink
                          to="/dv360"
                          className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                        >
                          DV360
                        </NavLink>
                      )}
                    {(userRole === "sales_user" ||
                      userRole === "admin" ||
                      userRole === "super_admin" ||
                      userRole === "client" ||
                      userRole === "demand" ||
                      userRole === "demo") && (
                        <NavLink
                          to="/ttd"
                          className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                        >
                          TTD
                        </NavLink>
                      )}
                    {(userRole === "sales_user" ||
                      userRole === "admin" ||
                      userRole === "super_admin" ||
                      userRole === "client" ||
                      userRole === "demand" ||
                      userRole === "demo") && (
                        <NavLink
                          to="/amazon"
                          className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                        >
                          Amazon DSP
                        </NavLink>
                      )}
                  </div>
                </li>


                {/* =============== USERS======================== */}
                {userRole === "super_admin" && (
                  <li>
                    <label
                      onClick={() => toggleSection("users")}
                      className={`d-flex justify-content-between ${isActive(routes.users) ? "active" : ""
                        }`}
                    >
                      <span className="d-flex align-items-center">
                        <i className="fa-solid fa-user-gear"></i> Users
                      </span>{" "}
                      <i className="fa-solid fa-chevron-down"></i>
                    </label>
                    <div id="users" className={`collapse inner-collapse ${openSections.users ? "show" : ""}`}>
                      <NavLink
                        to="/users"
                        className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                      >
                        Users
                      </NavLink>
                    </div>
                  </li>
                )}



                {/* =============== PARTNERS ======================== */}
                {(userRole === "admin" || userRole === "super_admin") && (
                  <li>
                    <label
                      onClick={() => toggleSection("partners")}
                      className={`d-flex justify-content-between ${isActive(routes.partners) ? "active" : ""
                        }`}
                    >
                      <span className="d-flex align-items-center">
                        <i class="fa-solid fa-briefcase"></i> Partners
                      </span>{" "}
                      <i className="fa-solid fa-chevron-down"></i>
                    </label>
                    <div id="partners" className={`collapse inner-collapse ${openSections.partners ? "show" : ""}`}>
                      <NavLink
                        to="/supplypartners"
                        className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                      >
                        Supply
                      </NavLink>
                      <NavLink
                        to="/demand-partners"
                        className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                      >
                        Demand
                      </NavLink>
                      <NavLink
                        to="/agency-partners"
                        className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                      >
                        Agency
                      </NavLink>
                      <NavLink
                        to="/brand-partners"
                        className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                      >
                        Brand
                      </NavLink>
                    </div>
                  </li>
                )}



                {/* =============== TOOLS ======================= */}
                {(userRole === "sales_user" ||
                  userRole === "admin" ||
                  userRole === "super_admin") && (
                    <li>
                      <label
                        onClick={() => toggleSection("tools")}
                        className={`d-flex justify-content-between ${isActive(routes.tool) ? "active" : ""
                          }`}
                      >
                        <span className="d-flex align-items-center">
                          <i className="fa-solid fa-gauge"></i> Tools
                        </span>{" "}
                        <i className="fa-solid fa-chevron-down"></i>
                      </label>
                      <div id="tools" className={`collapse inner-collapse ${openSections.tools ? "show" : ""}`}>
                        <NavLink
                          to="/deals"
                          className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                        >
                          Deals
                        </NavLink>
                        <NavLink
                          to="/map-deals"
                          className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                        >
                          Map Deals
                        </NavLink>

                        <NavLink
                          to="/segment-request"
                          className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                        >
                          Deal Requests
                        </NavLink>
                        <NavLink
                          to="/compare-deal"
                          className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                        >
                          Compare Deal
                        </NavLink>

                        
                        <NavLink
                          to="/suggestions"
                          className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                        >
                          Suggestions
                        </NavLink>
                      

                        {userId === brandmoId && (
                          <NavLink
                            to="/tasha"
                            title="BrandMo's Engine for Agentic Modeling"
                            className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                          >
                            BEAM
                          </NavLink>
                        )}
                      </div>
                    </li>
                  )}


                {/* ========================== Automation Hub ============================ */}
                {(userRole === "sales_user" ||
                        userRole === "admin" ||
                        userRole === "super_admin" ||
                        userRole === "client" ||
                        userRole === "demo") && (
                  <li>
                    <label
                      onClick={() => toggleSection("aiManagement")}
                      className={`d-flex justify-content-between ${isActive(routes.aiManagement) ? "active" : ""
                        }`}
                    >
                      <span className="d-flex align-items-center">
                        <i class="fa-solid fa-briefcase"></i>Automation Hub
                      </span>{" "}
                      <i className="fa-solid fa-chevron-down"></i>
                    </label>
                    <div id="aiManagement" className={`collapse inner-collapse ${openSections.aiManagement ? "show" : ""}`}>

                      
                      
                        <NavLink
                          to="/create-tag"
                          className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                        >
                          Richstream AI
                        </NavLink>
                      

                      
                        <NavLink
                          to="/site-app"
                          className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                        >
                          Site to App
                        </NavLink>
                      

                      
                        <NavLink
                          to="/site-expansion"
                          className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                        >
                          Site Expansion
                        </NavLink>


                      {userId != brandmoId && (
                          <NavLink
                            to="/tasha"
                            title="TeCreo's Agentic System for Human Assistance"
                            className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                          >
                            TASHA
                          </NavLink>
                        )}
                    </div>
                  </li>
                )}

                {/* ========================== Innovation Ads ============================ */}
                {(userRole === "sales_user" ||
                        userRole === "admin" ||
                        userRole === "super_admin" ||
                        userRole === "client" ||
                        userRole === "demo") && (
                  <li>
                    <label
                      onClick={() => toggleSection("innovationAds")}
                      className={`d-flex justify-content-between ${isActive(routes.innovationAds) ? "active" : ""
                        }`}
                    >
                      <span className="d-flex align-items-center">
                        <i class="fa-solid fa-bullhorn"></i>Innovation Ads
                        <span className="sidebar-new-badge">NEW</span>
                      </span>{" "}
                      <i className="fa-solid fa-chevron-down"></i>
                    </label>
                    <div id="innovationAds" className={`collapse inner-collapse ${openSections.innovationAds ? "show" : ""}`}>
                        <NavLink
                          to="/innovation-ads"
                          className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                        >
                          Innovation Ads
                        </NavLink>
                    </div>
                  </li>
                )}

                {/* ===========================  ANALYTICS  =======================  */}
                {(userRole === "sales_user" ||
                  userRole === "admin" ||
                  userRole === "super_admin") && (
                    <li>
                      <label
                        onClick={() => toggleSection("advanceAnalytics")}
                        className={`d-flex justify-content-between ${isActive(routes.advanceAnalytics) ? "active" : ""
                          }`}
                      >
                        <span className="d-flex align-items-center">
                          <i class="fa-solid fa-chart-pie"></i>Analytics
                        </span>{" "}
                        <i className="fa-solid fa-chevron-down"></i>
                      </label>
                      <div
                        id="advanceAnalytics"
                        className={`collapse inner-collapse ${openSections.advanceAnalytics ? "show" : ""}`}
                      >
                        <NavLink
                          to="/agency-overview"
                          className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                        >
                          Overview Agency
                        </NavLink>
                        <NavLink
                          to="/heatmap"
                          className={`menu-link ({ isActive }) => (isActive ? 'active' : '')}`}
                        >
                          Heat Map
                        </NavLink>
                      </div>
                    </li>
                  )}


              </>
            )}
          </ul>
        </div>
      </div>
      <div className={mobMenu ? "overlay" : ""}></div>
    </>
  );
};

export default SideBar;
